import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import {
  HTTP_BODY_PROVIDER_TOKEN,
  HTTP_ORDER_FILTERS_TOKEN,
  HTTP_ORDER_TOKEN,
  HTTP_PROVIDER_TOKEN,
} from '@epicuro-next/data-providers/providers-registry';
import { FiltersService, OrdersService } from '@epicuro-next/data/order-book';

import { HttpBodyProviderService } from './services/http-body-provider.service';
import { HttpProviderService } from './services/http-provider.service';

@NgModule({
  imports: [CommonModule, HttpClientModule],
  providers: [
    {
      provide: HTTP_PROVIDER_TOKEN,
      useClass: HttpProviderService,
    },
    {
      provide: HTTP_BODY_PROVIDER_TOKEN,
      useClass: HttpBodyProviderService,
    },
    {
      provide: HTTP_ORDER_FILTERS_TOKEN,
      useClass: FiltersService,
    },
    {
      provide: HTTP_ORDER_TOKEN,
      useClass: OrdersService,
    },
    HttpProviderService,
    HttpBodyProviderService,
    FiltersService,
    OrdersService,
  ],
})
export class HttpProviderModule {}
